import { CustomPrimaryUser } from 'api';
import BaseServiceRetryWrapper from './baseRetry';
import { USERS } from '../common/endpoints';

class UsersService extends BaseServiceRetryWrapper {
  getUsers = (firmId?: number, slim?: boolean): Promise<CustomPrimaryUser[]> => {
    let usersUrl = USERS.getUsers();
    const params = new URLSearchParams();

    if (firmId) {
      params.append('firm__id', firmId.toString());
    }

    if (slim) {
      params.append('slim', 'true');
    }

    if (params.toString()) {
      usersUrl += `?${params.toString()}`;
    }

    return this.get(usersUrl) as Promise<CustomPrimaryUser[]>;
  };

  getUserProfileById = (userId: number): Promise<any> => this.get(USERS.userProfileById(userId));

  getUserPermissions = (userId: number, firmId?: number): Promise<any> =>
    this.get(USERS.userPermissions(userId, firmId));

  getFirmUserPermissions = (firmId: number): Promise<any> => this.get(USERS.firmUserPermissions(firmId));

  getLowerUserPermissions = (userId: number): Promise<any> => this.get(USERS.lowerUserPermissions(userId));

  create = (data: unknown): Promise<any> => this.post(USERS.create(), data);

  savePermissions = (permissions: unknown): Promise<any> => this.put(USERS.savePermissions(), permissions);

  updateUserProfile = (userId: number, payload: unknown): Promise<any> =>
    this.put(USERS.updateUserProfile(userId), payload);

  deleteUser = (userId: string): Promise<any> => this.delete(USERS.deleteUser(userId));

  createBulkUsers = (data: unknown): Promise<any> => this.post(USERS.createBulkUsers(), data);

  deleteCompanyUserPermissions = (userId: number, companyId: number): Promise<any> =>
    this.delete(USERS.deleteCompanyUserPermissions(userId, companyId));
}

export default UsersService;
